import {
  useEffect,
  useState,
} from 'react';

// how often an open app asks for a new build; the browser itself only looks
// when the app is opened
const CHECK_EVERY_MS = 60 * 60 * 1000;

// Whether a new build has taken over from the one this page was loaded with.
// Its service worker takes over at once (../sw.ts), so this page still runs
// the old code until it's reloaded. A first install, taking over a page no
// worker had, isn't one; nor is anything under `yarn dev`, which has none.
export const useUpdateReady = () => {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const sw = 'serviceWorker' in navigator ? navigator.serviceWorker : null;
    if (!sw?.controller) return;
    const onChange = () => setReady(true);
    const check = () =>
      sw.getRegistration()
        .then(reg => reg?.update())
        .catch(e => console.error('update check failed', e));
    const onVisible = () => {
      if (document.visibilityState === 'visible') check();
    };
    const interval = setInterval(check, CHECK_EVERY_MS);
    sw.addEventListener('controllerchange', onChange);
    document.addEventListener('visibilitychange', onVisible);
    return () => {
      clearInterval(interval);
      sw.removeEventListener('controllerchange', onChange);
      document.removeEventListener('visibilitychange', onVisible);
    };
  }, []);

  return ready;
};
